/**
 * Activity Tracker - Throttled last_active_at updater
 * Max 1 update per 30 minutes (configurable via PLATFORM.ACTIVITY_THROTTLE_MS)
 */

import { supabase } from '@/integrations/supabase/client';
import { PLATFORM } from './constants';

const STORAGE_KEY = 'last_activity_update';

/**
 * Updates profiles.last_active_at for the current user, throttled.
 * Call on login, compare_event, review submit, etc.
 */
export async function updateLastActive(userId: string): Promise<void> {
  try {
    const lastUpdate = sessionStorage.getItem(STORAGE_KEY);
    if (lastUpdate) {
      const elapsed = Date.now() - parseInt(lastUpdate, 10);
      if (elapsed < PLATFORM.ACTIVITY_THROTTLE_MS) {
        return; // Throttled - skip update
      }
    }

    const { error } = await supabase
      .from('profiles')
      .update({ last_active_at: new Date().toISOString() })
      .eq('id', userId);

    if (!error) {
      sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
    }
  } catch (err) {
    // Non-critical - silently fail
    console.warn('[ActivityTracker] Failed to update last_active_at:', err);
  }
}
